require('./select.js');
module.exports = 'ui.select';
